UC.StripeCardElements = function() {
  this._stripe = null;
  this._cardNumberElement = null;
  this._mountedElements = [];
  this._elementState = {};
};

UC.StripeCardElements.prototype.init = function() {
  if (!document.getElementById('stripe-card-number')) return;

  this._stripe = null;
  this._mountedElements = [];
  this._elementState = {};

  this._stripe = UC.payments.createStripeClient();
  if (!this._stripe) return;

  var elements = this._stripe.elements();
  var style = {
    base: {
      fontSize: '15px',
      color: '#545E6B',
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      lineHeight: '40px',
      '::placeholder': { color: '#999999' }
    },
    invalid: { color: '#DC3200' }
  };

  var self = this;
  var fields = [
    { type: 'cardNumber', id: 'stripe-card-number' },
    { type: 'cardExpiry', id: 'stripe-card-expiry' },
    { type: 'cardCvc',   id: 'stripe-card-cvc' }
  ];

  fields.forEach(function(field) {
    var el = elements.create(field.type, { style: style });
    el.mount('#' + field.id);
    self._mountedElements.push(el);

    if (field.type === 'cardNumber') {
      self._cardNumberElement = el;
    }

    self._elementState[field.id] = { empty: true, error: null, complete: false };

    el.on('change', function(event) {
      self._elementState[field.id] = {
        empty: event.empty,
        error: event.error ? event.error.message : null,
        complete: event.complete
      };
      if (event.complete || (!event.empty && !event.error)) {
        $('#' + field.id).closest('.form-group').removeClass('has-error')
          .find('.error-message').text('');
      }
    });
  });
};

UC.StripeCardElements.prototype.clear = function() {
  this._mountedElements.forEach(function(el) { el.clear(); });
};

UC.StripeCardElements.prototype.isMounted = function() {
  return !!this._stripe && !!this._cardNumberElement;
};

UC.StripeCardElements.prototype.validate = function() {
  var fields = [
    { id: 'stripe-card-number', text: 'Please enter your card number.' },
    { id: 'stripe-card-expiry', text: 'Please enter a valid expiration date.' },
    { id: 'stripe-card-cvc',   text: 'Please enter your CVC.' }
  ];
  var valid = true;
  var self = this;

  fields.forEach(function(field) {
    var state = self._elementState[field.id] || { empty: true, error: null };
    var $container = $('#' + field.id).closest('.form-group');
    var message = state.error || (state.empty ? field.text : null);

    if (message) {
      $container.addClass('has-error').find('.error-message').text(message);
      valid = false;
    } else {
      $container.removeClass('has-error').find('.error-message').text('');
    }
  });

  return valid;
};

UC.StripeCardElements.prototype.tokenize = function(billingData, callback) {
  if (!this.isMounted()) {
    UC.utils.sendNesEvent('payments_error', { ERROR: UC.payments.STRIPE_NOT_READY_MESSAGE });
    callback(UC.payments.STRIPE_NOT_READY_MESSAGE);
    return;
  }

  this._stripe
    .createToken(this._cardNumberElement, billingData)
    .then(function(result) {
      if (result.error) {
        UC.utils.sendNesEvent('payments_error', { ERROR: result.error.message });
        callback(result.error.message);
      } else {
        callback(null, result.token.id, result.token.card);
      }
    })
    .catch(function(err) {
      var errorMessage = err && err.message ? err.message : UC.payments.STRIPE_NOT_READY_MESSAGE;
      UC.utils.sendNesEvent('payments_error', { ERROR: errorMessage });
      callback(errorMessage);
    });
};
